import { createFileRoute, notFound } from "@tanstack/react-router";

import { hasPermission } from "@blis/shared/permissions";

export const Route = createFileRoute("/_auth/_app/runs")({
  beforeLoad({ context: { user } }) {
    if (!hasPermission(user.role, "read:test_runs")) {
      throw notFound();
    }
  },
});
